<template>
  <div class="slider-container">


      <Swiper
          ref="mySwiper"
          :options="swiperOptions"
          :slides-per-view="1"
          :pagination="{ clickable: true }"
          :scrollbar="{ draggable: true }"
        >

          <SwiperSlide 
                v-for="(row, index) in rows" 
                :key="index"
                :data-swiper-autoplay="row.duration + '000'">
            <div class="slide-header" :style="'background-image: url('+row.file+');background-size: cover'">
                <div class="widget">
                    <div class="top-line" :style="'backgroundColor:'+row.lineColor"></div>
                    <div class="bg-title text-uppercase" v-html="row.title"></div>
                </div>
                <router-link v-if="row.button" 
                            :to="row.redirect" 
                            class="explore-btn" 
                            v-html="row.button">
                </router-link>
            </div>
          </SwiperSlide>
          <!-- If we need pagination -->
          <div class="swiper-pagination" slot="pagination"></div>
        
      </Swiper>

    <!-- <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide :data-swiper-autoplay="duration + '000'">
            <div class="slide-header" :style="{backgroundImage: `url(${require('../../assets/img/header.png')})`}">
                <div class="widget">
                    <div class="top-line" :style="{backgroundColor: `${'#04CC88'}`}"></div>
                    <div class="bg-title text-uppercase" v-html="'Global <br /> Association<br /> of Electrical<br /> Engineers '"></div>
                </div>
                <router-link to="/" class="explore-btn" v-html="'Explore'"></router-link>
            </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper> -->
  </div>
</template>

<style scoped>
.swiper-container {
    height: calc(100vh - 99.91px);
    min-height: 600px;
    position: relative;
}
.slide-header {
    height: 100%;
    background-size: cover;
}
.widget {
    position: absolute;
    left: 60px;
    bottom: 70px;
}
.bg-title {
    color: #fff;
    font-size: 55px;
}
.top-line {
    height: 11px;
    width: 120px;
    margin-bottom: 20px;
}
.explore-btn {
    writing-mode: vertical-rl;
  text-orientation: mixed;
  position: absolute;
  color: #fff;
  font-size: 22px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 70px;
}
/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
    
}

@media (max-width: 767.98px) {
  .swiper-container {
    height: auto;
    min-height: auto;
  }
  .slide-header {
    padding: 100px 20px 95px;
  }
  .widget {
    position: static;
  }
  .bg-title {
    font-size: 40px;
    margin-bottom: 24px;
  }
  .explore-btn {
    writing-mode: inherit;
    text-orientation: initial;
    position: static;
    transform: none;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  .bg-title {
    font-size: 56px;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .swiper-container {
    height: calc(100vh - 91.45px);
    /* min-height: auto; */
  }
  .slide-header {
    padding: 100px 20px 95px;
  }
  /* .widget {
    position: static;
  } */
  /* .bg-title {
    font-size: 40px;
    margin-bottom: 24px;
  } */
  .explore-btn {
    writing-mode: inherit;
    text-orientation: initial;
    /* position: static; */
    /* transform: none; */
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {

}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
// Very Important npm install swiper@5.4.5 
import axios from 'axios';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: "Slider",
//   props: ['row'],
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  
  data() {
    return {
      pgLoading: true,
      rows: [],
      duration: 4,
      swiperOptions: {
        loop: false,
        speed: 800,
        autoplay: {
            
          // delay: 4000, or data-swiper-autoplay="2000" in html
        },
        spaceBetween: 10,
        // slidesPerView: 3,
        navigation: {
            nextEl: '.swiperNext',
            prevEl: '.swiperPrev'
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets"
        },
      }
    };
  },
  created() {
      //
      this.fetchSlider();
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  methods: {
    prev() {
        this.$refs.mySwiper.$swiper.slidePrev();
    },
    next() {
        this.$refs.mySwiper.$swiper.slideNext();
    },
    fetchSlider() {
      axios
        .get(window.baseURL + "/sliders")
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;
        })
        .catch(() => {});
    },
  },
};
</script>
